import { DEV } from 'cc/env';
import { CCFloat, Node, Tween, v3, _decorator } from 'cc';
import ButtonEventEffect from './ButtonEventEffect';
import { calculateFrameTime } from '../../../Utils/Utility';

const { ccclass, property } = _decorator;

@ccclass('ScaleConfig')
class ScaleConfig {
    @property({ type: CCFloat, tooltip: DEV && '縮放倍率' })
    scale: number = 1;
    @property({ type: CCFloat, tooltip: DEV && '縮放時間' })
    duration: number = 0.1;

    constructor(scale: number = 1, duration: number = 0.1) {
        this.scale = scale;
        this.duration = duration;
    }
}

@ccclass('ButtonScaleEffect')
export default class ButtonScaleEffect extends ButtonEventEffect {
    @property({ type: [ScaleConfig], tooltip: DEV && '按下時的縮放配置' })
    private readonly pressScaleConfigs: ScaleConfig[] = [new ScaleConfig(0.95, calculateFrameTime(4))];

    @property({ type: [ScaleConfig], tooltip: DEV && '放開時的縮放配置' })
    private readonly releaseScaleConfigs: ScaleConfig[] = [new ScaleConfig(1.02, calculateFrameTime(3)), new ScaleConfig(1, calculateFrameTime(4))];

    @property({ tooltip: DEV && '縮放目標是否為按鈕目標' })
    private readonly scaleButtonTarget: boolean = true;

    private _currentTween: Tween<Node> = null;
    private _pressTween: Tween<Node> = null;
    private _releaseTween: Tween<Node> = null;
    private _isReleased: boolean = true;

    private get effectTarget(): Node {
        return this.scaleButtonTarget ? this.button.target : this.node;
    }

    public onLoad(): void {
        super.onLoad();
        this._pressTween = this.pressScaleConfigs.reduce(
            (tweenChain, config) => tweenChain.to(config.duration, { scale: v3(config.scale, config.scale, 1) }),
            new Tween(this.effectTarget),
        );
        this._releaseTween = this.releaseScaleConfigs.reduce(
            (tweenChain, config) => tweenChain.to(config.duration, { scale: v3(config.scale, config.scale, 1) }),
            new Tween(this.effectTarget),
        );
    }

    public simulate() {
        this._currentTween?.stop();
        this._isReleased = false;
        this._currentTween = this._pressTween
            .clone(this.effectTarget)
            .then(this._releaseTween)
            .call(() => {
                this._currentTween = null;
                this._isReleased = true;
            })
            .start();
    }

    protected onButtonTouchStart(): void {
        this._playPressTween();
    }

    protected onButtonTouchEnd(): void {
        this._playReleaseTween();
    }

    protected onButtonTouchMoveIn(): void {
        this._playPressTween();
    }

    protected onButtonTouchMoveOut(): void {
        this._playReleaseTween();
    }

    protected onButtonStateReset(): void {
        this._playReleaseTween();
    }

    private _playPressTween(): void {
        this._isReleased = false;
        this._currentTween?.stop();
        this._currentTween = this._pressTween
            ?.call(() => {
                this._currentTween = null;
            })
            .start();
    }

    private _playReleaseTween(): void {
        if (this._isReleased) {
            return;
        }
        this._currentTween?.stop();
        this._currentTween = this._releaseTween
            ?.call(() => {
                this._currentTween = null;
                this._isReleased = true;
            })
            .start();
    }
}
